<p-dialog
  styleClass="!bg-transparent !border-0 !shadow-none"
  [modal]="true"
  [visible]="visible"
  [dismissableMask]="true"
  (visibleChange)="_onVisibleChange($event)">
  <ng-template pTemplate="headless">
    <div class="relative flex items-center justify-center">
      <button
        type="button"
        class="absolute -top-2 -right-2 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-black/60 text-white hover:bg-black/80"
        (click)="_hide()">
        <ic-close-outline class="block h-5 w-5" />
      </button>
      @if (src) {
        <img
          [src]="src"
          class="max-h-[85vh] max-w-[90vw] rounded-lg object-contain"
          alt="Image preview" />
      }
    </div>
  </ng-template>
</p-dialog>
